const styles = () => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
    height: '100%',
    overflowY: 'scroll',
    width: 850,
  },

  header: {
    borderBottom: '1px solid rgba(155, 173, 188, 0.20)',
    padding: '27px 40px',
  },

  heading: {
    color: '#27282a',
    fontSize: 24,
    fontWeight: 600,
    margin: '0 0 5px',
    flex: '0 0 auto',
  },

  subheading: {
    color: '#596168',
    flex: '0 0 auto',
    fontSize: 15,
    fontWeight: 500,
    margin: '0 0 7px',
  },

  defaultSubheading: {
    color: '#596168',
    flex: '0 0 auto',
    fontSize: 15,
    fontWeight: 500,
    margin: '0 0 15px',
  },

  subtitle: {
    color: '#27282a',
    fontSize: 14,
    fontWeight: 500,
  },

  flow: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 18,
  },

  flowBox: {
    color: '#27282a',
    display: 'flex',
    fontSize: 16,
    fontWeight: 500,
    boxSize: 'border-box',
    alignItems: 'center',
  },

  flowArrow: {
    margin: '0 24px',
  },

  flowDetail: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    fontSize: 15,
    '& svg': {
      marginRight: 6,
    },
  },

  detailSub: {
    fontSize: 13,
    color: '#596168',
    display: 'flex',
    alignItems: 'center',
  },

  tile: {
    height: 40,
    margin: '0 12px 0 0',
    width: 40,
  },

  check: {
    marginRight: 6,
  },

  logo: {
    display: 'flex',
    margin: '0 15px 0 0',
  },

  content: {
    background: '#fafbfc',
    borderBottom: '1px solid rgba(155, 173, 188, 0.20)',
    flex: 1,
    padding: '24px 40px',
  },

  contentBox: {
    background: '#fff',
    border: '1px solid rgba(89, 97, 104, 0.15)',
    borderRadius: 8,
    margin: '24px 0 24px',
    padding: '20px 30px 30px',

    '& hr': {
      borderColor: 'inherit',
    },
  },

  columnsHelperText: {
    fontSize: 14,
    marginTop: 7,
    height: 'auto',
    color: '#596168',
    '& span': {
      marginTop: 7,
      fontWeight: 500,
      display: 'block',
      alignItems: 'baseline',
      '& svg': {
        marginRight: 6,
      },
    },
  },

  field: {
    '&:last-of-type': {
      marginBottom: 10,
    },
  },

  formControl: {
    display: 'block',
  },

  select: {
    display: 'block',
    width: 340,
  },

  triggerSubtext: {
    color: '#596168',
    fontSize: 14,
  },

  break: {
    margin: '20px -30px 24px -30px',
  },
});

export default styles;
